// Desktop: swap thumbnail -> main image and set active state
document.addEventListener('click', (e)=>{
  const btn = e.target.closest('.pl-thumb');
  if(!btn) return;
  const main = document.getElementById('plMainImage');
  if(!main) return;

  const url = btn.dataset.src;
  if(url){
    main.src = url;
    main.removeAttribute('srcset'); // avoid old candidates
  }

  document.querySelectorAll('.pl-thumb.is-active').forEach(b=>b.classList.remove('is-active'));
  btn.classList.add('is-active');
});

// Mobile carousel (scroll-snap + dots) — init ALL instances
document.addEventListener('DOMContentLoaded', function(){
  const carousels = Array.from(document.querySelectorAll('.pl-gallery-mobile'));
  if(!carousels.length) return;

  const isMobile = () => window.matchMedia('(max-width: 990px)').matches;

  function initCarousel(root){
    const track = root.querySelector('.pl-mc-track');
    const slides = Array.from(root.querySelectorAll('.pl-mc-slide'));
    const dotsWrap = root.querySelector('.pl-mc-dots');
    if(!track || !slides.length || !dotsWrap) return;

    function buildDots(){
      dotsWrap.innerHTML = '';
      slides.forEach((_, i) => {
        const b = document.createElement('button');
        b.className = 'dot' + (i === 0 ? ' is-active' : '');
        b.setAttribute('aria-label', 'Go to slide ' + (i+1));
        b.addEventListener('click', () => {
          const el = slides[i];
          const x = el.offsetLeft - (track.clientWidth - el.clientWidth)/2;
          track.scrollTo({ left: x, behavior: 'smooth' });
        });
        dotsWrap.appendChild(b);
      });
    }

    function updateDots(){
      if(!isMobile()) return;
      const dots = Array.from(dotsWrap.querySelectorAll('.dot'));
      if(!dots.length) return;
      const mid = track.scrollLeft + track.clientWidth/2;
      let best = 0, bestDist = Infinity;
      slides.forEach((el, i) => {
        const center = el.offsetLeft + el.clientWidth/2;
        const d = Math.abs(center - mid);
        if(d < bestDist){ bestDist = d; best = i; }
      });
      dots.forEach((d,n) => d.classList.toggle('is-active', n === best));
    }

    function enable(){
      if(isMobile()){
        buildDots();
        updateDots();
        track.addEventListener('scroll', updateDots, { passive: true });
      }else{
        dotsWrap.innerHTML = '';
        track.removeEventListener('scroll', updateDots);
      }
    }

    enable();
    window.addEventListener('resize', enable);
  }

  carousels.forEach(initCarousel);
});
